// import optionsClient from '@/client/options/definition/options.client';

/*
|-------------------------------------------------------------------------------
| Your option types can be defined below (refer to src/options/definition/option-types.js for syntax)
| Uncomment the needed import above
| See the README in this folder, or the docsify documentation for more information
|-------------------------------------------------------------------------------
*/

export default {
    // standard types (i.e. also exist in option-types.js)
    carousel: {},
    component: {},
    drawerCollection: {},
    dropdown: {},
    html: {},
    image: {},
    layeredContainer: {},
    layout: {},
    nav: {},
    table: {},
    text: {},
    video: {},
    visibility: {},

    // non-standard types
    // ... each type should be nested inside of misc, e.g. misc: { myOptionType: { ... } }
    misc: {},
};
